// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3nfiX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2DIQs"};